var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2H30.5C30.8978 2 31.2794 2.15804 31.5607 2.43934C31.842 2.72064 32 3.10218 32 3.5V24.5C32 24.8978 31.842 25.2794 31.5607 25.5607C31.2794 25.842 30.8978 26 30.5 26H3.5C3.10218 26 2.72064 25.842 2.43934 25.5607C2.15804 25.2794 2 24.8978 2 24.5V3.5Z",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2V26M8 2V26M27.5 9.5H32M27.5 18.5H32M2 9.5H6.5M2 8V11M5.75 2H10.25M5.75 26H10.25M23.75 2H28.25M23.75 26H28.25M2 18.5H6.5M2 17V20M32 17V20M32 8V11",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 10.25L20.75 14L14.75 17.75V10.25Z",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.9794d3ff2950a380bf787dbed9cc910c.svg";
export { ForwardRef as ReactComponent };